(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openDrawer(trigger) {
    var drawer = getDrawer();
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open(trigger || document.querySelector('#cart-icon-bubble') || document.activeElement);
    } else {
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }
  }

  function refreshDrawerThenOpen(trigger) {
    var drawer = getDrawer();
    if (!drawer) return;

    fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        if (sections && sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newCartDrawer = doc.querySelector('#CartDrawer');
          var currentCartDrawer = document.querySelector('#CartDrawer');
          if (newCartDrawer && currentCartDrawer) {
            var freshDrawer = doc.querySelector('cart-drawer');
            if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
          }
        }

        if (sections && sections['cart-icon-bubble']) {
          var docIcon = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newIcon = docIcon.querySelector('#cart-icon-bubble');
          var currentIcon = document.querySelector('#cart-icon-bubble');
          if (newIcon && currentIcon) {
            currentIcon.innerHTML = newIcon.innerHTML;
          }
        }

        var overlay = document.querySelector('#CartDrawer-Overlay');
        if (overlay && drawer && typeof drawer.close === 'function') {
          overlay.onclick = drawer.close.bind(drawer);
        }
        openDrawer(trigger);
      })
      .catch(function () {
        openDrawer(trigger);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cartLink = document.querySelector('.embr-cart-link');
    var drawer = getDrawer();
    if (cartLink && drawer) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', function (event) {
        event.preventDefault();
        refreshDrawerThenOpen(cartLink);
      });
    }
  });

  // Successful add-to-cart responses are handled by product-form.js and EO.add.
  // A fixed-delay submit fallback can race the request or reopen a closed drawer.
})();
